import { HookError } from 'components/ErrorBoundary';
import { ViewStateType, ViewReducerActionType } from './types';
import { ACTIONS } from 'constants/hook';

export const initialState: ViewStateType = {
  isPanelOpen: false,
  errorBoundary: {
    isVisible: false,
    seenCount: 0,
  },
  scrollToBottom: {
    hasSeenCTAThisMsg: false,
    isAutoScrollNextMsg: false,
    isCTAVisible: false,
    isLastMsgInView: false,
    unixTimeLastClickedCTA: undefined,
  },
};

export const viewReducer = (state: ViewStateType, action: ViewReducerActionType) => {
  switch (action.type) {
    case ACTIONS.CHANGE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case ACTIONS.RESET: {
      return initialState;
    }
    default: {
      throw new HookError(`Unhandled action type: ${action.type}`);
    }
  }
};
